export { MainMenuPage } from "./ui/main-menu-page"
